/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Rows from './Rows';
import TableHeader from './Header';

const TableBody = ({
    dateFrom, dayDiff, flightData, allRooms, roomAllocation, history, changeVisitModal, changeFlightModal,
}) => {
    const [selectedCellId, setSelectedCellId] = React.useState(null);
    const [previousCellStatus, setPreviousCellStatus] = React.useState(null);
    return ([
        <TableHeader
            dateFrom={dateFrom}
            withThead
            flightData={flightData}
            changeFlightModal={changeFlightModal}
            dayDiff={dayDiff}
            history={history}
            key="headerThead"
        />,
        <tbody key="tbodyData">
            {
                allRooms.map((obj) => {
                    const rows = [];
                    for (let x = 0; x < obj.RoomCount; x++) {
                        rows.push(<Rows
                            changeVisitModal={changeVisitModal}
                            day={dayDiff}
                            title={obj.RoomType__c}
                            subtitle="x"
                            rowSpan={x === 0 ? obj.RoomCount : 0}
                            startDate={dateFrom}
                            key={obj.RoomType__c + x}
                            data={roomAllocation}
                            rowNumber={x}
                            selectedCellId={selectedCellId}
                            setSelectedCellId={setSelectedCellId}
                            previousCellStatus={previousCellStatus}
                            setPreviousCellStatus={setPreviousCellStatus}
                        />);
                    }
                    if (['Palm Bungalow', 'Villa (2 Bedrooms)'].indexOf(obj.RoomType__c) > -1) {
                        rows.push(<TableHeader
                            dateFrom={dateFrom}
                            withThead={false}
                            flightData={flightData}
                            changeFlightModal={changeFlightModal}
                            dayDiff={dayDiff}
                            history={history}
                        />);
                    }
                    return rows;
                })}
        </tbody>,
    ]);
};

TableBody.propTypes = {
    dateFrom: PropTypes.objectOf(moment).isRequired,
    dayDiff: PropTypes.number.isRequired,
    flightData: PropTypes.array.isRequired,
    allRooms: PropTypes.array.isRequired,
    roomAllocation: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    changeVisitModal: PropTypes.func.isRequired,
    changeFlightModal: PropTypes.func.isRequired,
};

export default TableBody;

